import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { Button } from "@/components/ui/button";

export default function About() {
  return (
    <div>
      <Seo
        title="About CA HVAC Direct | California HVAC Direct"
        
description="Learn about CA HVAC Direct, an online store for HVAC equipment including air conditioners, furnaces, coils, air handlers, and mini-splits."

        path="/about"
      />
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 sm:py-20 lg:grid-cols-2 lg:gap-14 lg:px-8">
          <div className="flex flex-col justify-center">
            <span className="text-xs font-semibold uppercase tracking-widest text-sky-700">About</span>
            <h1 className="mt-2 font-heading text-4xl font-black tracking-tight text-slate-900 sm:text-5xl">
              HVAC Equipment Made Simple
            </h1>
            <p className="mt-5 text-slate-600">
              
CA HVAC Direct is an online destination for HVAC equipment. Our goal is to make shopping for heating and cooling products easier by bringing equipment from established manufacturers together in one convenient place.

            </p>
            <p className="mt-4 text-slate-600">
              
Browse our catalog of air conditioners, furnaces, coils, air handlers, mini-splits, and more. Compare available equipment options, explore product details, and contact us with questions about purchasing equipment.

            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Button asChild className="rounded-sm bg-sky-700 hover:bg-sky-800">
                <Link to="/shop">Shop Equipment <ArrowRight className="h-4 w-4" /></Link>
              </Button>
              <Button asChild variant="outline" className="rounded-sm border-slate-300">
                <Link to="/contact">Contact Us</Link>
              </Button>
            </div>
          </div>

          <div className="flex min-h-[320px] items-center justify-center rounded-sm border border-slate-200 bg-slate-50 p-12">
  <img
    src="/logo.png"
    alt="CA HVAC Direct logo"
    className="max-h-[240px] w-full max-w-[420px] object-contain"
  />
</div>
        </div>
      </section>

      <section className="bg-slate-50">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
          <div className="grid gap-6 md:grid-cols-3">
            {[
              { h: "Equipment First", b: "We focus specifically on HVAC equipment — not a general marketplace." },
              { h: "Trusted Brands", b: "Browse equipment from several established manufacturers in one place." },
              { h: "Real Support", b: "Talk to a real person before you buy. We're happy to help you decide." },
            ].map((c) => (
              <div key={c.h} className="rounded-sm border border-slate-200 bg-white p-6">
                <h3 className="font-heading text-lg font-bold tracking-tight text-slate-900">{c.h}</h3>
                <p className="mt-2 text-sm text-slate-600">{c.b}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
